export type DescriptiveErrorOptions = {
  /**
   * Loggable error message
   */
  message: string;
  /**
   * User-friendly title for the error
   */
  title?: string;
  /**
   * User-friendly subtitle for the error
   */
  subtitle?: string;
};

export class DescriptiveError extends Error {
  /**
   * Displayable title for the error
   */
  public title?: string;

  public subtitle?: string;
  constructor({ message, title, subtitle }: DescriptiveErrorOptions) {
    super(message);
    this.title = title;
    this.subtitle = subtitle;
    this.name = 'DescriptiveError';
  }
}
